import LinkToDocusaurus from '../LinkToDocusaurus'
import { monitorAvailability } from '../../docs-routes'

const LinkToMonitorAvailabilityDashboardDoc = () =>
  <LinkToDocusaurus path={monitorAvailability}>
    Learn more about Monitor Availability
  </LinkToDocusaurus>

export default LinkToMonitorAvailabilityDashboardDoc
